import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M372-446h64v-106h88v106h64v-178l-108-72-108 72v178Zm108 276q130-118 193-211 62-93 62-173 0-115-74-188t-181-73q-107 0-181 73t-74 188q0 80 64 173t191 211Zm0 82q-12 0-24-4-13-4-22-13-45-39-96-89-50-50-93-108t-71-122q-28-64-28-130 0-155 101-248t233-93 234 93q101 93 101 248 0 66-29 130-28 64-71 122t-93 108q-51 50-96 89-9 9-22 13-12 4-24 4Zm0-472Z"/>',
  f: '<path d="M372-446h64v-106h88v106h64v-178l-108-72-108 72v178ZM480-88q-12 0-24-4-13-4-22-13-45-39-96-89-50-50-93-108t-71-122q-28-64-28-130 0-155 101-248t233-93 234 93q101 93 101 248 0 66-29 130-28 64-71 122t-93 108q-51 50-96 89-9 9-22 13-12 4-24 4Z"/>',
};

export default data;
